import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
import CmsShellNav from './cms-shell-nav';
function isEmbeddedInIframe() {
    try {
        return typeof window !== 'undefined' && window.self !== window.top;
    }
    catch {
        return true;
    }
}
/**
 * CMS shell: full-height sidebar + scrollable main content.
 */
const CmsShellLayout = () => {
    const embedded = isEmbeddedInIframe();
    return (_jsxs("div", { className: "cms-mfe-shell", "data-cms-embedded": embedded ? 'true' : 'false', children: [_jsx(CmsShellNav, { variant: "sidebar" }), _jsx("main", { className: "cms-mfe-shell__main", children: _jsx("div", { className: "cms-mfe-shell__outlet", children: _jsx(Outlet, {}) }) })] }));
};
export default CmsShellLayout;
